module.exports = __webpack_public_path__ + "img/gh-12205.asm.b2662262.jpg";